 
import PropTypes from 'prop-types';

import {
  COLOR_BLACK,
  COLOR_RED,
  COLOR_RED_AND_WHITE,
  COLOR_WHITE,
  COLOR_WHITE_AND_RED,
  COLOR_YELLOW_AND_BLACK,
  PADDING_LARGE,
  PADDING_NO_PADDING,
  PADDING_SMALL
} from './Label.config';

/** @namespace Bodypwa/Component/Label/Component/LabelComponent */
export const LabelComponent = ({
  text,
  color = COLOR_WHITE,
  isFontBold = false,
  isTextUppercase = false,
  id = '',
  size = PADDING_SMALL,
  className = '',
  isBorder = false
}) => {
    const borderClass = isBorder ? 'shadow-[0_0_0_1px_var(--color-bmBorder-default)]' : '';
    const sizeClass = {
        [PADDING_LARGE]: 'px-2 py-1',
        [PADDING_SMALL]: 'p-1',
        [PADDING_NO_PADDING]: 'p-0'
    };

    const backgroundColor = {
        [COLOR_WHITE]: 'bg-bmBg-default text-bmText-default whitespace-nowrap',
        [COLOR_WHITE_AND_RED]: 'bg-bmBg-default text-bmStatus-sale',
        [COLOR_BLACK]: 'bg-bmBg-inverted text-bmText-inverted',
        [COLOR_RED]: 'bg-bmStatus-sale text-bmText-inverted',
        [COLOR_YELLOW_AND_BLACK]: 'bg-bmBg-brand text-bmText-default',
        [COLOR_RED_AND_WHITE]: 'bg-bmStatus-sale text-bmText-inverted'
    };

    const fontClass = isFontBold ? 'font-bold' : 'font-normal';
    const textClass = isTextUppercase ? 'uppercase' : 'normal-case';

    if(!text) {
      return null
    }

    return (
        <div id={ id } className={ `text-p12 w-fit h-fit z-50 flex flex-row gap-1
         ${borderClass} ${fontClass} ${textClass} ${className}
          ${backgroundColor[color]} ${sizeClass[size]}` }>
            { text }
        </div>
    );
};

LabelComponent.propTypes = {
  text: PropTypes.string.isRequired,
  color: PropTypes.string,
  size: PropTypes.string,
  isFontBold: PropTypes.bool,
  isTextUppercase: PropTypes.bool,
  className: PropTypes.string,
  isBorder: PropTypes.bool
};

export default LabelComponent;
